<template>
  <div class="expandable-text">
    <h2 class="title">{{ title }}</h2>
    <p class="description">
      {{ isExpanded ? fullText : truncatedText }}
    </p>
    <button class="toggle-btn" @click="toggleExpand">
      {{ isExpanded ? "Show less" : "Show more" }}
    </button>
  </div>
</template>
<script>
export default {
  name: "ExpandableText",
  props: {
    title: String,
    fullText: String,
    limit: {
      type: Number,
      default: 260,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    truncatedText() {
      return this.fullText.slice(0, this.limit) + "...";
    },
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>
<style scoped>
.expandable-text {
  background-color: rgb(31 31 36);
  padding: 24px;
  border-radius: 24px;
  color: #dcdce4;
  margin-top: 24px;
  text-align: center;
}

.title {
  font-weight: 800;
  margin-bottom: 12px;
  color: white;
  font-size: 1.5rem;
  line-height: 2rem;
  text-align: left;
}

.description {
  font-size: 0.825rem;
  line-height: 1.6;
  color: rgb(121 121 134);
  font-weight: 500;
  text-align: left;
}

.toggle-btn {
  background: none;
  border: none;
  color: #e0c28b;
  font-weight: 600;
  margin-top: 12px;
  cursor: pointer;
}
</style>
